var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H2C0.897187 0 0 0.897187 0 2V7C0 8.10281 0.897187 9 2 9H14C15.1028 9 16 8.10281 16 7V2C16 0.897187 15.1028 0 14 0ZM3.25 8V7H12.75V8H3.25ZM15 7C15 7.55141 14.5514 8 14 8H13.75V6.5C13.75 6.22388 13.5262 6 13.25 6H2.75C2.47384 6 2.25 6.22388 2.25 6.5V8H2C1.44859 8 1 7.55141 1 7V5H14C14.2762 5 14.5 4.77612 14.5 4.5C14.5 4.22388 14.2762 4 14 4H1V2C1 1.44859 1.44859 1 2 1H14C14.5514 1 15 1.44859 15 2V7Z",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.5C3.72384 9.5 3.5 9.72387 3.5 10V13C3.5 13.5514 3.05141 14 2.5 14C2.22384 14 2 14.2239 2 14.5C2 14.7761 2.22384 15 2.5 15C3.60281 15 4.5 14.1028 4.5 13V10C4.5 9.72387 4.27616 9.5 4 9.5Z",
    fill: "#696969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15C13.1986 15 12.75 14.5514 12.75 14V10.75C12.75 10.4739 12.5262 10.25 12.25 10.25C11.9738 10.25 11.75 10.4739 11.75 10.75V14C11.75 15.1028 12.6472 16 13.75 16C14.0262 16 14.25 15.7761 14.25 15.5C14.25 15.2239 14.0262 15 13.75 15Z",
    fill: "#696969"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15C8.94859 15 8.5 14.5514 8.5 14V11.25C8.5 10.9739 8.27616 10.75 8 10.75C7.72384 10.75 7.5 10.9739 7.5 11.25V14C7.5 15.1028 8.39719 16 9.5 16C9.77616 16 10 15.7761 10 15.5C10 15.2239 9.77616 15 9.5 15Z",
    fill: "#696969"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.25C5.72384 10.25 5.5 10.4739 5.5 10.75V14.5C5.5 14.7761 5.72384 15 6 15C6.27616 15 6.5 14.7761 6.5 14.5V10.75C6.5 10.4739 6.27616 10.25 6 10.25Z",
    fill: "#696969"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5C9.72384 9.5 9.5 9.72387 9.5 10V12.75C9.5 13.0261 9.72384 13.25 10 13.25C10.2762 13.25 10.5 13.0261 10.5 12.75V10C10.5 9.72387 10.2762 9.5 10 9.5Z",
    fill: "#696969"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.75C13.7761 2.75 14 2.52614 14 2.25C14 1.97386 13.7761 1.75 13.5 1.75C13.2239 1.75 13 1.97386 13 2.25C13 2.52614 13.2239 2.75 13.5 2.75Z",
    fill: "#696969"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.75C11.7761 2.75 12 2.52614 12 2.25C12 1.97386 11.7761 1.75 11.5 1.75C11.2239 1.75 11 1.97386 11 2.25C11 2.52614 11.2239 2.75 11.5 2.75Z",
    fill: "#696969"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAc);
export default __webpack_public_path__ + "static/media/ac.d31a1cd692bbc400ab336f93a344f90a.svg";
export { ForwardRef as ReactComponent };